import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

class ReportShareStore extends ReduceStore {

    getInitialState() {
        return {};
    }

    getResultsByKey(key) {
        return (this.getState()[key] || {}).results;
    }

    getKeyByReportId(reportId) {
        const state = this.getState();
        return Object.keys(state).find((key) => state[key].reportId === reportId);
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.REPORT_SHARE_INFO_SUCCESS:
                return {
                    ...state,
                    [action.data.shareKey] : { reportId: action.payload.reportId, results: {} }
                };
            case ActionTypes.REPORT_SHARE_ADD_SUCCESS:
                return {
                    ...state,
                    [action.data] : { reportId: action.payload.reportId, results: {} }
                };
            case ActionTypes.REPORT_SHARE_DELETE_SUCCESS:
                const newState = { ...this.getState() };
                delete newState[action.payload.shareKey];
                return newState;
            case ActionTypes.REPORT_SHARE_RESULTS_SUCCESS:
                return {
                    ...state,
                    [action.payload.key] : { ...state[action.payload.key], results: action.data }
                };
            default:
                return state;
        }
    }
}

export default new ReportShareStore(CentricDispatcher);
